import "./notfound.css"

function NotFound() {
    return (
        <div>404 NOT FOUND</div>
    );
}

export default NotFound;